import React from "react";

const SideSection = ({ imageUrl }) => {
  return (
    <div className="bg-white w-full h-screen shadow-lg overflow-hidden flex-col">
      {/* Top Image (only visible on large screens) */}
      <div className="hidden lg:flex h-1/2 w-full overflow-hidden">
        <img
          src={imageUrl}
          alt="Travel Promo"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Bottom Section with Background Decoration */}
      <div className="relative bg-pink-50 h-full lg:h-1/2 overflow-hidden flex flex-col justify-center px-8">
        {/* Large decorative logo placed bottom right */}
        <img
          src="/images/LogoNoName.png"
          alt="Decorative Logo"
          className="absolute bottom-0 right-0 w-auto h-full pointer-events-none select-none"
        />

        {/* Text Content */}
        <div className="relative z-10">
          <div className="text-pink-600 font-bold text-l flex gap-5 mb-10">
            <img src="./images/logo.png" className="w-20" alt="" />
          </div>
          <h2 className="text-6xl font-semibold text-gray-900 mb-4">
            Simplify Your Travel Experience Today.
          </h2>
          <p className="text-gray-700 text-lg mt-10">
            Book rides, find local guides, and secure stays—all in one place, effortlessly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SideSection;